import { Button, Form } from 'antd'

import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import useCreatePTOV3 from 'hooks/pto-v3/use-create-pto-v3'
import BaseInformation from 'modules/pto-v3/form/base-information'
import CoTrustedPartners from 'modules/pto-v3/form/co-trusted-partners'
import Properties from 'modules/pto-v3/form/properties'
import UploadFile from 'modules/pto-v3/form/upload-file'

import './style.scss'

/**
 * PTO v3 (ERC-3643) create screen: same layout as PTO v2 create, with the v3
 * Basic Information (Token Symbol added, Royalty removed) and without the
 * metadata / golden tickets section (an ERC-3643 token has no token metadata). The token is deployed
 * through PTOOrchestrator.createPTO with BE-built calldata.
 */
const CreatePTOV3 = () => {
  const additionalItems = [BREADCRUMBS.PTO_V3, BREADCRUMBS.PTO_V3_CREATE_NO_LINK]
  const [form] = Form.useForm()

  const {
    thumbnail,
    setThumbnail,
    thumbnails,
    setThumbnails,
    propertyTypes,
    isSubmitting,
    handleSubmit,
    handleCancel,
  } = useCreatePTOV3({ form })

  return (
    <div className="p2p-create">
      <Breadcrumb additionalItems={additionalItems} />
      <Form
        form={form}
        layout="vertical"
        initialValues={{ remember: true }}
        style={{ padding: '20px 10px' }}
        onFinish={handleSubmit}
        scrollToFirstError={{
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        }}
      >
        <BaseInformation form={form} edit={true} mode="create" />

        <Properties form={form} edit={true} propertyTypes={propertyTypes} mode="create" />

        <UploadFile
          edit={true}
          form={form}
          defaultThumbnail={thumbnail}
          defaultThumbnails={thumbnails}
          onUpload={(data) => {
            setThumbnail(data)
          }}
          onUploadMulti={(data) => {
            setThumbnails(data)
          }}
        />

        <CoTrustedPartners form={form} edit={true} mode="create" />

        <div style={{ textAlign: 'center', paddingBottom: 5 }}>
          <Button style={{ marginRight: 15 }} key="back" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            disabled={thumbnail.length === 0 || thumbnails.length === 0 || isSubmitting}
            key="submit"
            type="primary"
            htmlType="submit"
            loading={isSubmitting}
          >
            Create
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default CreatePTOV3
